export const stripHtmlAndTruncate = (html: string, maxLength: number = 50): string => {
  if (!html) return '';

  if (typeof document !== 'undefined' && document.createElement) {
    const div = document.createElement('div');
    div.innerHTML = html;
    const text = (div.textContent || div.innerText || '').trim();
    return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
  }

  // Fallback for non-browser environments: minimal best-effort stripping
  const text = String(html).replace(/<|>/g, '').trim();
  return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
};
